export default __webpack_public_path__ + "68d34664626eb3dfeb7e30178b597436.woff2";